import React from 'react';
import renderIf from '../../../pkgs/render_if';

import {Table} from 'react-bootstrap';
import PropTypes from 'prop-types';

export default class Stopwatch extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isMounted:false,
            client_browser_time_is_further_back_than_the_server:false,
            start:'',
            milliseconds:'00',
            hours:'00',
            minutes:'00',
            seconds:'00',
        };
    }

    componentDidMount = () => {
        let start = this.props.start_time;
        //console.log('stopwatch componentdidmount start');
        //console.log(start);
        this.SecondMinuteHourLoopTimer = setInterval( () => this.loopTimer(), 1000);
        this.setState({start});
    }

    componentWillReceiveProps = (nextProps) => {
        let start = nextProps.start_time;
        //console.log('stopwatch componentwillreceiveprops start');
        //console.log(start);
        this.setState({start});
    }

    formatTimer = (a) => {
        if (a < 10) {
            a = '0' + a;
        }
        return a;
    }

    componentWillUnmount = () => {
        clearInterval(this.SecondMinuteHourLoopTimer);
    }

    loopMilliseconds = () => {
        let milliseconds = Number(this.state.milliseconds);
        if (milliseconds < 9 ) {
            milliseconds = milliseconds + 1;
            milliseconds = '0' + String(milliseconds);
            this.setState({milliseconds});
        } else {
            if (milliseconds > 9 && milliseconds < 99 || milliseconds === 9) {
                milliseconds = milliseconds + 1;
                milliseconds = String(milliseconds);
                this.setState({milliseconds});
            } else {
                if (milliseconds === 99) {
                    this.setState({milliseconds:'00'});
                }
            }
        }
    }

    loopTimer = () => {
        moment.suppressDeprecationWarnings = true;
        let start = moment(this.state.start).format();
        let now = moment(new Date()).format();
        let time_delta = moment.duration(moment(now).diff(start)).asMilliseconds();
        if (time_delta > 0) {
            let duration = moment.utc(time_delta).format('HH:mm:ss');
            let hours = String(duration).split(':')[0];
            let minutes = String(duration).split(':')[1];
            let seconds = String(duration).split(':')[2];

            this.setState({hours, minutes, seconds});
        } else {
            this.setState({client_browser_time_is_further_back_than_the_server:true});
        }
    }

    render() {

        return (
            <div>
                {renderIf(this.state.client_browser_time_is_further_back_than_the_server === true)(
                    <h3>The time on your device is wrong. Updating...</h3>
                )}
                {renderIf(this.state.client_browser_time_is_further_back_than_the_server === false)(
                    <div>
                        <Table style={{width:'150px'}}>
                            <tbody>
                                <tr>
                                    <td style={{textAlign:'center', fontSize:'29pt'}}>
                                        <div>{this.state.hours}</div>
                                    </td>
                                    <td style={{textAlign:'center', fontSize:'29pt'}}>
                                        <div>:</div>
                                    </td>
                                    <td style={{textAlign:'center', fontSize:'29pt'}}>
                                        <div>{this.state.minutes}</div>
                                    </td>
                                    <td style={{textAlign:'center', fontSize:'29pt'}}>
                                        <div>:</div>
                                    </td>
                                    <td style={{textAlign:'center', fontSize:'29pt'}}>
                                        <div>{this.state.seconds}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{textAlign:'center'}}>
                                        <div style={{fontSize:'7pt'}}>hours</div>
                                    </td>
                                    <td style={{textAlign:'center'}}>
                                        <div style={{fontSize:'7pt'}}></div>
                                    </td>
                                    <td style={{textAlign:'center'}}>
                                        <div style={{fontSize:'7pt'}}>minutes</div>
                                    </td>
                                    <td style={{textAlign:'center'}}>
                                        <div style={{fontSize:'7pt'}}></div>
                                    </td>
                                    <td style={{textAlign:'center'}}>
                                        <div style={{fontSize:'7pt'}}>seconds</div>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                )}
            </div>
        );
    }
}

Stopwatch.propTypes = {
    start_time: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/helpers/stopwatch/stopwatch.js